export default "__VITE_ASSET__BivqzoZy__"